import NumberValueObject from '@/domain/shared/number/NumberValueObject';

export default class DataBreachNumberAffected extends NumberValueObject {}
